import { isAllowedToPerformFeature } from '../../services/permissions/permissionHelper';
import { DASHBOARD_PERMISSIONS } from './dashboardContract';

const hasPermission = (permission) => isAllowedToPerformFeature(permission);

export const canViewDashboard = () => hasPermission(DASHBOARD_PERMISSIONS.VIEW);

export const canCreateDashboard = () =>
  canViewDashboard() && hasPermission(DASHBOARD_PERMISSIONS.TEMPLATE_CREATE);

export const canDesignDashboard = () =>
  canViewDashboard() && hasPermission(DASHBOARD_PERMISSIONS.TEMPLATE_UPDATE);

export const canPublishDashboard = () =>
  canViewDashboard() && hasPermission(DASHBOARD_PERMISSIONS.PUBLISH);

export const canViewDashboardData = () =>
  canViewDashboard() && hasPermission(DASHBOARD_PERMISSIONS.DATA_VIEW);

export const canUpdateDashboardData = () =>
  canViewDashboard() && hasPermission(DASHBOARD_PERMISSIONS.DATA_UPDATE);

export const canRemoveDashboardData = () =>
  canViewDashboard() && hasPermission(DASHBOARD_PERMISSIONS.DATA_REMOVE);

export const canImportDashboardData = () =>
  canUpdateDashboardData() && hasPermission(DASHBOARD_PERMISSIONS.IMPORT);

export const canViewDashboardApprovals = () =>
  canViewDashboard() &&
  hasPermission(DASHBOARD_PERMISSIONS.DATA_VIEW) &&
  hasPermission(DASHBOARD_PERMISSIONS.APPROVALS_VIEW);

export const canReviewDashboardValues = () =>
  canViewDashboard() && hasPermission(DASHBOARD_PERMISSIONS.APPROVALS_REVIEW);

export const getDashboardCapabilities = () => ({
  canView: canViewDashboard(),
  canCreate: canCreateDashboard(),
  canDesign: canDesignDashboard(),
  canPublish: canPublishDashboard(),
  canViewData: canViewDashboardData(),
  canUpdateData: canUpdateDashboardData(),
  canRemoveData: canRemoveDashboardData(),
  canImportData: canImportDashboardData(),
  canViewApprovals: canViewDashboardApprovals(),
  canReviewValues: canReviewDashboardValues()
});
